// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","homepageLayout":"_2PH_u"};